export const CLASS_ALWAYS_PREPARED_SPELLS_SET = 'serviceData.CLASS_ALWAYS_PREPARED_SPELLS_SET';
export const CLASS_ALWAYS_PREPARED_SPELLS_SET_COMMIT = 'serviceData.CLASS_ALWAYS_PREPARED_SPELLS_SET_COMMIT';
